export const IMPUESTO_CATEGORIA = {
  IVA: 0,
  RETENCION: 1,
  IPSI: 2,
  IGIC: 3,
  OTROS: 4,
} as const

export type ImpuestoCategoriaType =
  (typeof IMPUESTO_CATEGORIA)[keyof typeof IMPUESTO_CATEGORIA]
